"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.titleTemplate = void 0;
var tslib_1 = require("tslib");
var title_dot_1 = (0, tslib_1.__importDefault)(require("./title.dot"));
var titleTemplate = title_dot_1.default.default ? title_dot_1.default.default : title_dot_1.default;
exports.titleTemplate = titleTemplate;
//# sourceMappingURL=index.js.map